const updateObject = (oldObject, updatedValues) => {
  return {
    ...oldObject,
    ...updatedValues,
  };
};

// eslint-disable-next-line import/prefer-default-export
export { updateObject };
